import { jsx as m } from "react/jsx-runtime";
import { c as i } from "react/compiler-runtime";
import { StepLabel as s } from "@mui/material";
import { forwardRef as f } from "react";
const L = f((p, l) => {
  const e = i(7);
  let o, r;
  e[0] !== p ? ({
    children: o,
    ...r
  } = p, e[0] = p, e[1] = o, e[2] = r) : (o = e[1], r = e[2]);
  let t;
  return e[3] !== o || e[4] !== r || e[5] !== l ? (t = /* @__PURE__ */ m(s, { ref: l, ...r, children: o }), e[3] = o, e[4] = r, e[5] = l, e[6] = t) : t = e[6], t;
});
export {
  L as StepLabel
};
